import { Button, Col, OverlayTrigger, Row, Tooltip } from "react-bootstrap";

import { DateTime, Settings } from "luxon";

import {
  getServiceOrderTypeValuesByType,
  ServiceOrderType,
} from "../../../_constants/serviceOrder.ts";
import { capitalizeWord, getDateFromIso } from "../../../_helpers/stringHelper";
import Key from "../../../assets/svg/Key";
import { ORDER_VIEW } from "../../order/routes";
import { IService } from "../../serviceOrdering/reducers";
import { AgendaRangeMinute } from "../types";

Settings.defaultLocale = "fr";

export interface AgendaEventComponentProps {
  color: string;
  keyState?: boolean;
  range: AgendaRangeMinute;
  service: IService;
}

const AgendaEventComponent = ({
  color,
  range,
  service,
}: AgendaEventComponentProps) => {
  const backgroundRGB = hexToRgb(color);
  const backgroundColor =
    "rgba(" +
    backgroundRGB?.r +
    ", " +
    backgroundRGB?.g +
    ", " +
    backgroundRGB?.b +
    ", 0.1)";
  const description =
    `${service.dwelling.address.address.address}, ${service.dwelling.address.address.zip} ${service.dwelling.address.address.city}` ||
    null;
  let duration = 60;
  let serviceDateTime, serviceDateTimeEnd;
  if (service.appointment) {
    if (service.appointment.endDate) {
      duration = DateTime.fromISO(service.appointment.endDate).diff(
        DateTime.fromISO(service.appointment.startDate),
        "minutes",
      ).minutes;
    }
    serviceDateTime = DateTime.fromISO(service.appointment.startDate).toFormat(
      "EEEE dd MMMM - HH:mm",
    );
    serviceDateTimeEnd = getDateFromIso(
      service.appointment.endDate,
      DateTime.TIME_24_SIMPLE,
      "en attente",
    );
  }

  let keyState;
  switch (service.dwelling?.key?.lastStatus?.status.order) {
    case 1:
      keyState = { color: "#ECB900" };
      break;
    case 2:
      keyState = { color: "#11BFA4" };
      break;
    case 3:
      keyState = { color: "#FF0000" };
      break;
    default:
      keyState = { color: "#8A8C8F" };
      break;
  }

  function hexToRgb(hex: string) {
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result
      ? {
          r: parseInt(result[1], 16),
          g: parseInt(result[2], 16),
          b: parseInt(result[3], 16),
        }
      : null;
  }

  let userFullName;

  if (service?.user) {
    userFullName = `${service.user.firstname} ${capitalizeWord(
      service.user.lastname,
    )}`;
  }
  const getStatusColor = function (name: string | undefined) {
    switch (name) {
      case "Attente Dwell":
        return "#ECB900";
        break;
      case "Attente locataire":
        return "#ECB900";
        break;
      case "Rappel 1":
        return "#FF7D29";
        break;
      case "Rappel 2":
        return "#EF3826";
        break;
      case "Planifié":
        return "#11BFA4";
        break;
      case "Intervenu":
        return "#641ABF";
        break;

      default:
        return "#777";
        break;
    }
  };
  const popover = (
    <Tooltip className="popover" placement="bottom">
      <div className="d-flex gap-2 align-items-start text-start">
        <div
          className="mt-1"
          style={{
            backgroundColor: color,
            width: "8px",
            height: "8px",
            borderRadius: "2px",
          }}
        ></div>
        <div>
          {keyState === undefined ? (
            <p className="title-event m-0">
              {
                getServiceOrderTypeValuesByType(
                  service.type as ServiceOrderType,
                )?.label
              }
            </p>
          ) : (
            <Row>
              <Col md={9} xs={9}>
                <p className="title-event m-0">
                  {
                    getServiceOrderTypeValuesByType(
                      service.type as ServiceOrderType,
                    )?.label
                  }
                </p>
              </Col>
              <Col md={2} xs={2}>
                <div className="me-5">
                  <Key color={keyState.color} />
                </div>
              </Col>
            </Row>
          )}
          <p className="text-event m-0">{description}</p>
          <p className="text-event m-0 mt-2">
            {serviceDateTime} à {serviceDateTimeEnd}
          </p>
          {userFullName && (
            <p className="text-event m-0 mt-2">
              Intervenant: <u>{userFullName}</u>
            </p>
          )}
          <p className="text-event m-0 mt-2">
            <a
              href={ORDER_VIEW.replace(
                ":id",
                service.datedReference || service.id || "",
              )}
              className="link"
            >
              Suivre la commande
            </a>
          </p>
        </div>
      </div>
    </Tooltip>
  );

  return (
    <div className="event">
      <OverlayTrigger trigger="focus" placement="bottom" overlay={popover}>
        <Button
          variant="none"
          style={{
            width: "100%",
            border: "1px solid" + color,
            backgroundColor: backgroundColor,
            overflow: "hidden",
            height: 43.5 * (60 / range) * (duration / 60) + "px",
            backgroundBlendMode: "screen",
            backdropFilter: "blur(10px)",
          }}
        >
          <div className="d-flex justify-content-between text-truncate">
            <div
              className="agenda-status me-2"
              style={{
                backgroundColor: getStatusColor(
                  service.appointment?.lastStatus?.status.status,
                ),
              }}
            ></div>
            <div className="text-truncate">
              <p
                className="title-event m-0 text-truncate"
                style={{ color: color }}
              >
                {
                  getServiceOrderTypeValuesByType(
                    service.type as ServiceOrderType,
                  )?.label
                }
              </p>
              <p
                className="text-event m-0 text-truncate"
                style={{ color: color }}
              >
                {description}
              </p>
            </div>
            {keyState !== undefined && (
              <div className="ms-1 me-1">
                <Key color={keyState.color} />
              </div>
            )}
          </div>
          <div className="mt-2">
            {userFullName && (
              <p
                className="text-event m-0 text-truncate"
                style={{ color: color }}
              >
                Intervenant: <u>{userFullName}</u>
              </p>
            )}
          </div>
        </Button>
      </OverlayTrigger>
    </div>
  );
};
export default AgendaEventComponent;
